<script setup lang="ts">
/**
 * UI-kit component
 * Category: Typography
 * Name: 'Headers/H5'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=216-126907&m=dev'
*/

defineOptions({
  name: 'HeadingH5',
})
</script>

<template>
  <h5 class="heading-h5">
    <slot />
  </h5>
</template>

<style scoped lang="scss" src="./HeadingH5.scss" />
